/**
 * Textes de /v70 : la V60 (paiement direct, prix de lancement) tournée vers l'alimentation.
 * Promesse : toutes les recettes de Gaut (des assiettes qui ont l'air de cheat meals, mais n'en sont pas) + une liste de courses CHAQUE semaine
 * envoyée automatiquement chaque lundi (à brancher : rien ne l'envoie encore). L'appel mensuel est inclus mais facultatif.
 * Énergie : on vend « retrouver son énergie / en finir avec le coup de barre de 15 h », jamais une garantie
 * médicale (« tu ne seras plus jamais fatigué ») : la fatigue peut avoir d'autres causes (FAQ santé).
 */

import BASE from './openBroV60Copy';

const swapAnswer = (faq, question, answer) => faq.map(([q, a]) => (q === question ? [q, answer] : [q, a]));
const dropFaq = (faq, question) => faq.filter(([q]) => q !== question);

/** Sortie « continuer seul » : le McDonald's américain. */
const ALONE_HREF = 'https://www.mcdonalds.com/us/en-us.html';

const COPY = {
  fr: {
    ...BASE.fr,
    eyebrow: 'Nutrition · Les recettes de Gaut Bonac',
    title: 'Mange comme Gaut.\nSans te priver.\n**Dès ce soir.**',
    lead: 'Burger, pizza, tacos : **les recettes de Gaut** ont l’air de cheat meals, mais sont faites avec les bons ingrédients. Et **chaque lundi, ta liste de courses arrive toute seule**, quantités comprises. **Tu n’as plus à te demander quoi manger.**',
    between: '',
    // L'appel mensuel reste expliqué plus bas (section appel, FAQ) : pas dans le haut de page.
    bookLater: '',
    secondary: 'Voir la différence',
    reassure: ['Accès immédiat aux recettes', 'Sans engagement', 'Résiliable par simple email'],
    // Offre de lancement : seulement des faits du code. Vraie date de fin (offer.launchEndsAt = Worker), vrai prix d'après,
    // 99 € barré en euros seulement. Pas de places limitées ni de « dernière chance » inventées.
    sacTag: ({ pct, day }) => (pct ? `−${pct} jusqu’à ${day}` : `Jusqu’à ${day}`),
    sacBanner: ({ price, was, next }) => (was ? `~~${was}~~ **${price}/mois**, bloqué tant que tu restes. Retour à ${was} dans` : `**${price}/mois**, bloqué tant que tu restes. Retour à ${next} dans`),
    sacGo: 'J’en profite',
    launchPill: ({ pct, day }) => (pct ? `−${pct} jusqu’à ${day}` : `Jusqu’à ${day}`),
    launchLine: ({ price, was, next, end }) => `${was ? `~~${was}~~ **${price}/mois**` : `**${price}/mois**`} jusqu’au ${end}. **Ensuite, ${next}.** Rejoins avant : tu gardes ${price} par mois tant que tu restes membre.`,
    cdTitle: ({ next }) => `Retour à ${next} dans`,
    cd: { d: 'jours', h: 'heures', m: 'min', s: 'sec' },
    cdShort: { d: 'j', h: 'h', m: 'min', s: 's' },
    dealNote: ({ price, was, next, compact }) => `${was ? `~~${was}~~ ` : ''}**${price}/mois** · retour à ${next} dans **${compact}**`,
    barLaunch: ({ next, compact }) => `Retour à ${next} dans ${compact}`,
    finalDeal: ({ price, next, endShort }) => `**${price}/mois** jusqu’à ${endShort}. Ensuite, **${next}.**`,
    launchFaq: ({ price, next, end }) => [`Pourquoi ${price} ?`, `C’est le prix de lancement, **jusqu’au ${end}**. Ensuite, l’abonnement passe à ${next} pour les nouveaux membres. Si tu rejoins avant, **tu gardes ${price} par mois** tant que tu restes abonné.`],
    ctaDeal: ({ price, was }) => (was ? `Rejoindre · ~~${was}~~ ${price}/mois` : `Rejoindre pour ${price}/mois`),

    truthPill: 'Tu te reconnais ?',
    truthTitle: 'Coup de barre à 15 h ? **Ce n’est pas une fatalité.**',
    truth: [
      'Réveil difficile. Café sur café. Du sucre pour tenir l’après-midi. Le grignotage devant l’écran. **Et le lendemain, rebelote.**',
      'Tu n’es pas « fait comme ça ». Très souvent, **le coup de barre commence dans l’assiette** : des repas qui ne calent pas, pris n’importe quand.',
      '**Les recettes de Gaut sont faites pour tenir toute la journée.** Tu arrêtes de subir tes après-midi. **Tu retrouves ton énergie, tu te sens mieux, plus en forme.**',
    ],

    stay: 'Même frigo, mêmes plats tout faits. **Dans 30 jours, tu en es au même point.**',
    go: '**Les recettes de Gaut et la liste de courses chaque semaine.** Sans engagement.',
    storiesTitle: 'Les recettes de Gaut. **Les vraies.**',
    stories: {
      burger: ['01', 'Haut secret'],
      pizza: ['02', 'Haut secret'],
      taco: ['03', 'Haut secret'],
      bowl: ['04', 'Haut secret'],
      bites: ['05', 'Haut secret'],
      pancakes: ['06', 'Haut secret'],
    },

    pathsTitle: 'Seul devant ton frigo **vs** OpenBro',
    aloneHref: ALONE_HREF,
    nothingHref: ALONE_HREF,
    alone: [
      'Tu ne sais jamais quoi acheter',
      'Tu manges ce qui traîne',
      'Coup de barre tous les après-midi',
      'Régime le lundi, craquage le jeudi',
      'Tu culpabilises dès que tu te fais plaisir',
      'Personne pour te répondre',
    ],
    with: [
      'Toutes les recettes de Gaut',
      'Ta nouvelle liste de courses chaque semaine',
      'Des assiettes qui font envie, et qui restent saines',
      'Le campus Nutrition & Performance, et les 5 autres',
      'Une communauté qui partage ses assiettes',
      'Un appel avec Gaut chaque mois, si tu le veux',
    ],
    perks: [
      'Toutes les recettes de Gaut : l’air d’un cheat meal, sans en être un',
      'Une nouvelle liste de courses chaque semaine',
      'Le campus Nutrition & Performance, et les 5 autres',
      'La communauté privée',
      'Un appel privé avec Gaut chaque mois (facultatif)',
      'Sur mobile et ordinateur',
    ],
    toasts: [
      // null après la fin de l'offre : Toasts saute ce toast.
      (f) => (f.ends ? [`Jusqu’à ${f.ends}`, `${f.price}/mois`, `ensuite ${f.next}`, f.previous] : null),
      BASE.fr.toasts[0],
      () => ['Chaque lundi', 'Ta liste de courses arrive toute seule', 'Tu n’as rien à faire'],
      () => ['Accès immédiat', 'Toutes les recettes de Gaut', 'L’air d’un cheat meal, sans en être un'],
    ],
    callPill: 'En bonus',
    callTitle: 'Un appel avec Gaut.\n**Si tu le veux.**',
    call: (minutes) => [
      `Chaque mois, tu peux réserver un appel avec Gaut${minutes ? ` (**${minutes} min en tête-à-tête**)` : ''} pour un plan sur mesure. **C’est facultatif** : les recettes et la liste de courses de la semaine suffisent pour commencer.`,
      'Tu choisis ton créneau juste après le paiement, ou plus tard.',
    ],

    timePill: 'Chaque semaine',
    timeTitle: 'Ta liste de courses **arrive chaque lundi.**',
    time: [
      'Chaque lundi, **tu reçois automatiquement ta nouvelle liste de courses** : exactement ce qu’il faut acheter pour les recettes de la semaine, quantités comprises. Rien à chercher, rien à télécharger.',
      '**Fini le « on mange quoi ce soir ? ».** En magasin, tu suis la liste, tu coches, c’est réglé.',
    ],
    planPill: 'Les recettes de Gaut',
    planTitle: 'On dirait un cheat meal. **Ça n’en est pas un.**',
    plan: [
      '**Toutes les recettes de Gaut**, celles qu’il mange vraiment.',
      '**Des assiettes qui ont l’air d’un cheat meal** : burger, pizza, tacos maison… mais faits avec les bons ingrédients. **Tu te fais plaisir, et ça reste sain.**',
      '**Des repas qui calent**, simples, rapides, avec des produits de supermarché.',
      '**Des portions pour ton objectif**, sans tout peser.',
    ],
    coursesShot: 'Aperçu de l’espace membre : la liste de courses de la semaine',

    formationsPill: 'Le campus Nutrition en premier',
    formationsTitle: 'Ton assiette d’abord. **Puis tout le reste.**',
    formationsBody: 'Le campus **Nutrition & Performance** avec toutes les recettes de Gaut, et les 5 autres campus inclus. **Tu commences par ce qui compte pour toi.**',

    winsBody: 'Des membres qui partagent **leurs assiettes, leurs séances et leurs progrès.** De l’inspiration chaque jour.',

    faq: [
      ['Qu’est-ce que je reçois exactement ?', '**Toutes les recettes de Gaut**, des assiettes qui font envie, et **chaque lundi une nouvelle liste de courses, que tu reçois automatiquement.** Plus le campus Nutrition & Performance, les 5 autres campus et la communauté.'],
      ['Un burger ou une pizza, c’est vraiment sain ?', 'Oui, dans ces recettes. **Ça a l’air d’un cheat meal, mais ça n’en est pas un** : Gaut les prépare avec les bons ingrédients et les bonnes portions. Tu te fais plaisir sans sortir de ton plan, et c’est ce qui permet de tenir sur la durée.'],
      ['Ça va m’aider contre la fatigue ?', 'C’est le but : **des repas qui calent, au bon moment**, pour en finir avec les coups de barre liés à ce que tu manges. Si ta fatigue dure malgré tout, parles-en à un médecin : elle peut avoir d’autres causes.'],
      ['L’appel est obligatoire ?', 'Non. **L’appel mensuel avec Gaut est inclus, mais facultatif.** Tu peux simplement suivre les recettes et la liste de courses de la semaine.'],
      ['Je dois suivre un régime strict ?', 'Non. **Les recettes partent de vrais repas**, simples et bons. Pas d’aliments interdits, pas de pesée à chaque repas.'],
      ...dropFaq(
        swapAnswer(BASE.fr.faq, 'Les résultats sont-ils garantis ?', 'Non. **Tu as les recettes, la liste de courses et un cadre.** Le travail, c’est toi qui le fais, et chaque corps réagit différemment.'),
        'Les vidéos et les messages, c’est qui ?',
      ),
    ],

    finalTitle: 'Reçois ta première liste de courses **dès lundi.**',
    finalBro: 'Dans 7 jours, tu peux avoir **fait tes courses avec la liste de Gaut et cuisiné ses recettes toute la semaine.** Ou être encore devant ton frigo, à te demander quoi manger.',
    pageTitle: 'OpenBro · Les recettes et la liste de courses de Gaut Bonac',
  },
  en: {
    ...BASE.en,
    eyebrow: 'Nutrition · Gaut Bonac’s recipes',
    title: 'Eat like Gaut.\nNo starving.\n**Starting tonight.**',
    lead: 'Burgers, pizza, tacos: **Gaut’s recipes** look like cheat meals, but they’re made with the right ingredients. And **every Monday, your shopping list shows up on its own**, quantities included. **No more wondering what to eat.**',
    between: '',
    bookLater: '',
    secondary: 'See the difference',
    reassure: ['Instant access to the recipes', 'No commitment', 'Cancel with a simple email'],
    sacTag: ({ pct, day }) => (pct ? `−${pct} until ${day}` : `Until ${day}`),
    sacBanner: ({ price, was, next }) => (was ? `~~${was}~~ **${price}/month**, locked in while you stay. Back to ${was} in` : `**${price}/month**, locked in while you stay. Back to ${next} in`),
    sacGo: 'Grab it',
    launchPill: ({ pct, day }) => (pct ? `−${pct} until ${day}` : `Until ${day}`),
    launchLine: ({ price, was, next, end }) => `${was ? `~~${was}~~ **${price}/month**` : `**${price}/month**`} until ${end}. **Then ${next}.** Join before and you keep ${price} a month as long as you stay.`,
    cdTitle: ({ next }) => `Back to ${next} in`,
    cd: { d: 'days', h: 'hours', m: 'min', s: 'sec' },
    cdShort: { d: 'd', h: 'h', m: 'm', s: 's' },
    dealNote: ({ price, was, next, compact }) => `${was ? `~~${was}~~ ` : ''}**${price}/month** · back to ${next} in **${compact}**`,
    barLaunch: ({ next, compact }) => `Back to ${next} in ${compact}`,
    finalDeal: ({ price, next, endShort }) => `**${price}/month** until ${endShort}. Then **${next}.**`,
    launchFaq: ({ price, next, end }) => [`Why ${price}?`, `It’s the launch price, **until ${end}**. After that, the membership goes to ${next} for new members. Join before and **you keep ${price} a month** as long as you stay subscribed.`],
    ctaDeal: ({ price, was }) => (was ? `Join · ~~${was}~~ ${price}/month` : `Join for ${price}/month`),

    truthPill: 'Sound familiar?',
    truthTitle: 'Crashing at 3 PM? **It doesn’t have to be that way.**',
    truth: [
      'Hard mornings. Coffee after coffee. Sugar to get through the afternoon. Snacking in front of a screen. **And the next day, same thing.**',
      'You’re not “just like that”. Very often, **the crash starts on your plate**: meals that don’t keep you going, eaten at random times.',
      '**Gaut’s recipes are built to keep you going all day.** Stop putting up with your afternoons. **Get your energy back, feel better, feel fitter.**',
    ],

    stay: 'Same fridge, same ready meals. **In 30 days, you’re in the same place.**',
    go: '**Gaut’s recipes and a new shopping list every week.** No commitment.',
    storiesTitle: 'Gaut’s recipes. **The real ones.**',
    stories: {
      burger: ['01', 'High secret'],
      pizza: ['02', 'High secret'],
      taco: ['03', 'High secret'],
      bowl: ['04', 'High secret'],
      bites: ['05', 'High secret'],
      pancakes: ['06', 'High secret'],
    },

    pathsTitle: 'Alone in front of your fridge **vs** OpenBro',
    aloneHref: ALONE_HREF,
    nothingHref: ALONE_HREF,
    alone: [
      'You never know what to buy',
      'You eat whatever is around',
      'A crash every afternoon',
      'Diet on Monday, cave on Thursday',
      'You feel guilty every time you treat yourself',
      'Nobody to answer you',
    ],
    with: [
      'All of Gaut’s recipes',
      'Your new shopping list every week',
      'Plates that look indulgent, and stay healthy',
      'The Nutrition & Performance campus, and the other 5',
      'A community that shares its plates',
      'A monthly call with Gaut, if you want it',
    ],
    perks: [
      'All of Gaut’s recipes: they look like cheat meals, they aren’t',
      'A new shopping list every week',
      'The Nutrition & Performance campus, and the other 5',
      'The private community',
      'A private monthly call with Gaut (optional)',
      'On phone and computer',
    ],
    toasts: [
      (f) => (f.ends ? [`Until ${f.ends}`, `${f.price}/month`, `then ${f.next}`, f.previous] : null),
      BASE.en.toasts[0],
      () => ['Every Monday', 'Your shopping list arrives on its own', 'Nothing to do'],
      () => ['Instant access', 'All of Gaut’s recipes', 'Looks like a cheat meal. Isn’t one'],
    ],
    callPill: 'Bonus',
    callTitle: 'A call with Gaut.\n**If you want it.**',
    call: (minutes) => [
      `Every month, you can book a call with Gaut${minutes ? ` (**${minutes} min, one to one**)` : ''} for a tailored plan. **It’s optional**: the recipes and this week’s shopping list are enough to get started.`,
      'You pick your time right after paying, or later.',
    ],

    timePill: 'Every week',
    timeTitle: 'Your shopping list **lands every Monday.**',
    time: [
      'Every Monday, **your new shopping list comes to you automatically**: exactly what to buy for that week’s recipes, quantities included. Nothing to look for, nothing to download.',
      '**No more “what’s for dinner?”.** In the store, follow the list, check it off, done.',
    ],
    planPill: 'Gaut’s recipes',
    planTitle: 'Looks like a cheat meal. **It isn’t one.**',
    plan: [
      '**All of Gaut’s recipes**, the ones he actually eats.',
      '**Plates that look like cheat meals**: burgers, pizza, homemade tacos… made with the right ingredients. **You treat yourself, and it stays healthy.**',
      '**Meals that keep you full**, simple, quick, with supermarket ingredients.',
      '**Portions for your goal**, without weighing everything.',
    ],
    coursesShot: 'Member area preview: this week’s shopping list',

    formationsPill: 'Nutrition campus first',
    formationsTitle: 'Your plate first. **Then everything else.**',
    formationsBody: 'The **Nutrition & Performance** campus with all of Gaut’s recipes, plus the 5 other campuses included. **Start with what matters to you.**',

    winsBody: 'Members sharing **their plates, their workouts and their progress.** Daily inspiration.',

    faq: [
      ['What exactly do I get?', '**All of Gaut’s recipes**, plates you actually crave, and **a new shopping list every Monday, sent to you automatically.** Plus the Nutrition & Performance campus, the 5 other campuses and the community.'],
      ['Is a burger or a pizza really healthy?', 'In these recipes, yes. **It looks like a cheat meal, but it isn’t one**: Gaut makes them with the right ingredients and portions. You treat yourself without leaving your plan, and that’s what makes it last.'],
      ['Will it help with tiredness?', 'That’s the goal: **meals that keep you full, at the right time**, to put an end to food-related afternoon crashes. If your tiredness lasts anyway, talk to a doctor: it can have other causes.'],
      ['Is the call mandatory?', 'No. **The monthly call with Gaut is included, but optional.** You can simply follow the recipes and this week’s shopping list.'],
      ['Do I have to follow a strict diet?', 'No. **The recipes are real meals**, simple and tasty. No banned foods, no weighing every meal.'],
      ...dropFaq(
        swapAnswer(BASE.en.faq, 'Are results guaranteed?', 'No. **You get the recipes, the shopping list and structure.** The work is yours to do, and every body responds differently.'),
        'Who are the people in the videos and messages?',
      ),
    ],

    finalTitle: 'Get your first shopping list **this Monday.**',
    finalBro: 'In 7 days, you can have **shopped with Gaut’s list and cooked his recipes all week.** Or still be standing in front of your fridge, wondering what to eat.',
    pageTitle: 'OpenBro · Gaut Bonac’s recipes and weekly shopping list',
  },
};

export default COPY;
